module.exports = __webpack_public_path__ + "media/images/admin/icons/folder-131f06eb968394918a3f4b04151f5a03.svg";